import React,{useContext} from "react";
import { NavLink } from "react-router-dom";
import { AppContext } from "../../AppContext";

const SidebarComp = (props)=>{
    
  const [appContext, setAppContext] = useContext(AppContext);
  const isJwCole = appContext.clientId === "jwcole"?true:false;
  const isASN = appContext.clientId === "asn" ? true : false;

    const sidebarClass = props.collapsed?"sidebar sidebar-collapsed":"sidebar";
    
    const app_feaatures = JSON.parse(appContext.appFeature.EMP_PORTAL_FEATURES);
   
    return(

        <div className={sidebarClass}>
            <ul>
                <li>
                    <NavLink className="sidebar-item" exact activeClassName="sidebar-selected" to="/home">
                        <img className="icon64" src="img/icon/sidebar_dashboard.svg" alt="collapse menu"/>
                        <span className="sidebar-item-label">My Dashboard</span>
                    </NavLink>
                </li>
                
                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Attestation') &&
                    <li>
                        <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/attestation">
                            <img className="icon64" src="img/icon/sidebar_attestation.svg" alt="collapse menu"/>
                            <span className="sidebar-item-label">My Attestations</span>
                        </NavLink>
                    </li>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Document') &&
                    <li>
                        <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/documents">
                            <img className="icon64" src="img/icon/my-document.svg" alt="collapse menu"/>
                            <span className="sidebar-item-label">My Documents</span>
                        </NavLink>
                    </li>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'OBA') &&
                    <li>
                        <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/oba">
                            <img className="icon64" src="img/icon/sidebar_oba.svg" alt="collapse menu"/>
                            <span className="sidebar-item-label">Outside Business Activities</span>
                        </NavLink>
                    </li>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Gift') &&
                <li>
                    <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/gift">
                        <img className="icon64" src="img/icon/sidebar_gift.svg" alt="collapse menu"/>
                        <span className="sidebar-item-label">Gifts & Entertainment</span>
                    </NavLink>
                </li>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'Political') &&
                <li>
                    <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/political">
                        <img className="icon64" src="img/icon/sidebar_political.svg" alt="collapse menu"/>
                        <span className="sidebar-item-label">Political Contributions & Donations</span>
                    </NavLink>
                </li>
                }

                { app_feaatures.features.request_types.some(req_type => req_type.name === 'PreTrade') &&
                    <li>
                        <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/pretrade">
                            <img className="icon64" src="img/icon/sidebar_pretrade.svg" alt="collapse menu"/>
                            <span className="sidebar-item-label">Pre-Trade Requests</span>
                        </NavLink>
                    </li>
                }

                <li>
                    <NavLink className="sidebar-item"  activeClassName="sidebar-selected" to="/brokerage">
                        <img className="icon64" src="img/icon/sidebar_brokerage.svg" alt="collapse menu"/>
                        <span className="sidebar-item-label">My Brokerage &<br/>Investment Accounts</span>
                    </NavLink>
                </li>
            </ul>
        </div>
    );

};


export default SidebarComp;